import {initPlasmicLoader} from "@plasmicapp/loader-react";

export const PLASMIC = initPlasmicLoader({
    projects: [
        {
            id: "bTrGofFi7x5qwd3cb6nAtt",  // ID of a project you are using
            token: "TJHiwpKdkyFHSy3oQJ2dAuMHtOuB9OfN48sJBg860hm5DgdkxPb3Fl7WQ2HLg9PhsiaPJ8gkcjWy5UrIUfA"  // API token for that project
        }
    ],
    // Fetches the latest revisions, whether or not they were unpublished!
    // Disable for production to ensure you render only published changes.
    // preview: true,
})
